import MembersAccessGroupItem from './MembersAccessGroupItem.component';

export default MembersAccessGroupItem;
